/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_With_ClientInputs */

const cs_chat_with_client = /** @type {(inputs: Chat_With_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat s klientem`)
};

const en_chat_with_client = /** @type {(inputs: Chat_With_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client portal chat`)
};

/**
* | output |
* | --- |
* | "Client portal chat" |
*
* @param {Chat_With_ClientInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_with_client = /** @type {((inputs?: Chat_With_ClientInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_With_ClientInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_with_client(inputs)
	return cs_chat_with_client(inputs)
});